// Locale-tudatos személy-név formázás. Tiszta függvény: a locale-t a hívó adja (i18n.language) — így
// tesztelhető és nincs rejtett i18n-függése. A magyar névsorrend vezetéknév-elöl (pl. „Reizner Szilárd"),
// minden más locale keresztnév-elöl (pl. „Szilárd Reizner"). Ha a strukturált név-részek hiányoznak, a
// megjelenítendő névre (displayName) esünk vissza, végső soron a „—" helyőrzőre.

/** Egy személy név-részei (az Odin OIDC-claimekből / foundation-identity sorokból). */
export interface NameParts {
  givenName?: string | null | undefined;
  familyName?: string | null | undefined;
  /** A fallback megjelenítendő név (pl. az identity displayName-je vagy e-mailje). */
  displayName?: string | null | undefined;
}

/** Üres/whitespace → undefined; egyébként a trim-elt string. */
function nonEmpty(v: string | null | undefined): string | undefined {
  const x = v?.trim();
  if (!x) return undefined;
  return x;
}

/** Igaz, ha a locale a magyar nyelvre mutat (`hu`, `hu-HU`, …). */
function isHungarian(locale: string): boolean {
  return locale.toLowerCase().split('-')[0] === 'hu';
}

/**
 * Locale-tudatos teljes-név. Ha van keresztnév ÉS vezetéknév is:
 *   • `hu` locale → „{vezetéknév} {keresztnév}" (magyar sorrend),
 *   • minden más → „{keresztnév} {vezetéknév}".
 * Ha bármelyik hiányzik → a `displayName` fallback, annak hiányában „—".
 */
export function formatName(
  { givenName, familyName, displayName }: NameParts,
  locale: string,
): string {
  const given = nonEmpty(givenName);
  const family = nonEmpty(familyName);
  if (given && family) {
    return isHungarian(locale) ? `${family} ${given}` : `${given} ${family}`;
  }
  return nonEmpty(displayName) ?? '—';
}
